// Gerado no build por scripts/version.js. Nao editar a mao.
export const APP_VERSION = "1.0.1"
